import React, { useContext } from 'react'
import { styled } from 'styled-components'

import { PairElementContext } from './pair-element-context'
import { PairLink } from './pair-link'

type Props = React.HTMLAttributes<HTMLElement>

export const PairElementContainer: React.FC<Props> = ({ ...props }) => {
  const context = useContext(PairElementContext)

  if (context.useLinkForBadge && context.pair) {
    return <StyledLink pair={context.pair} {...props} />
  }

  return <StyledDiv {...props} />
}

const StyledDiv = styled.div`
  pointer-events: auto;
  display: grid;
`

const StyledLink = styled(PairLink)`
  pointer-events: auto;
  display: grid;
`
